import { render, staticRenderFns } from "./create-queue.vue?vue&type=template&id=68b96e2a&scoped=true&"
import script from "./create-queue.vue?vue&type=script&lang=ts&"
export * from "./create-queue.vue?vue&type=script&lang=ts&"
import style0 from "./create-queue.vue?vue&type=style&index=0&id=68b96e2a&prod&lang=scss&scoped=true&"
import style1 from "./create-queue.vue?vue&type=style&index=1&id=68b96e2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b96e2a",
  null
  
)

export default component.exports